import { ExplorePerformanceDataSelectorsResponse, JurisInfo, StatisticsList, SubgroupsList, VariableList } from '../../../redux/explorePanel/models';
import { ICheckBox } from '../../NQTCheckBox/NQTCheckBox.models';
import { IMixedCheckBox } from '../../NQTMixedCheckBox/NQTMixedCheckBox.models';
import { JurisInfoReducer, PerformanceDataOutput, StandardErrorOptions, SubgroupsListReducer, VariableListReducer } from './ExplorePanel.types';


export const jurisInfoReducer = (pdSelectors: ExplorePerformanceDataSelectorsResponse): JurisInfoReducer =>  (acc: IMixedCheckBox[], curr: JurisInfo): IMixedCheckBox[] => {
  const entries = Object.entries(curr.jurisdictionInfo);
  const childList = entries.reduce((ac: ICheckBox[], cur) => {
    const obj = {
      jurisdictionCode: cur[0],
      jurisdictionLabel: cur[1],
      isSelected: pdSelectors.defaultJurisID === cur[0]
    };
    return [...ac, obj];
  }, []);
  const filteredChildList = childList.filter(child => child.isSelected);
  const obj = {
    label: curr.levelLabel,
    isSelected: childList.length === filteredChildList.length,
    childList
  };

  return [...acc, obj];

};

export const variableListReducer = (pdSelectors: ExplorePerformanceDataSelectorsResponse): VariableListReducer =>
  (acc: VariableList[], curr: [string, string|boolean|undefined]) => {
    const obj: VariableList = {
      variableCode: curr[0],
      variableLabel: curr[1],
      isSelected: pdSelectors.defaultVariableID === curr[0]
    };

    return [...acc, obj];
  };

export const subgroupsListReducer = (pdSelectors: ExplorePerformanceDataSelectorsResponse): SubgroupsListReducer =>
  (acc: SubgroupsList[], curr: [string, string|boolean|undefined]) => {
    const obj: SubgroupsList = {
      variableCode: curr[0],
      variableLabel: curr[1],
      isSelected: pdSelectors.defaultVariableID === curr[0]
    };

    return [...acc, obj];
  };

export const statisticsListReducer = (acc: StatisticsList[], curr: [string, string|boolean|undefined]): StatisticsList[] => {
  const obj: StatisticsList = {
    statCode: curr[0],
    statLabel: curr[1],
    isSelected: true
  };

  return [...acc, obj];
};

export const isPerformanceDataOutput = (str: string): str is PerformanceDataOutput => (
  str === 'CHART' ||
  str === 'TABLE'
);

export const isStandardErrorOptions = (str: string): str is StandardErrorOptions => (
  str === 'ON' ||
  str === 'OFF'
);